import { render, staticRenderFns } from "./MNManagementTemplates.vue?vue&type=template&id=18365c6e&"
import script from "./MNManagementTemplates.vue?vue&type=script&lang=ts&"
export * from "./MNManagementTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports